import * as Sentry from '@sentry/vue'
import Cookies from 'js-cookie'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import FieldCreator from './components/js/Components/UI/Form/FieldCreator.vue'
import { globalMethodsMixin, globalVariablesMixin } from './components/js/Mixins/global.js'
import jsonRequestMixins from './components/js/Mixins/jsonRequestMixins.js'
import { arrayGet } from './components/js/Utils/array.js'
import { getNumber, getRound, getRoundFloat } from './components/js/Utils/numeric.js'
import { addValue, setValue } from './components/js/Utils/object.js'
import ClientContractListPage from './components/js/Views/ClientContractListPage.vue'
import ContractListPage from './components/js/Views/ContractListPage.vue'
import ContractViewPage from './components/js/Views/ContractViewPage.vue'
import DemandListPage from './components/js/Views/DemandListPage.vue'
import EntityListPage from './components/js/Views/EntityListPage.vue'
import EquipmentListPage from './components/js/Views/EquipmentListPage.vue'
import InvoiceListPage from './components/js/Views/InvoiceListPage.vue'
import KpiPage from './components/js/Views/KpiPage.vue'
import SignatureErrorPage from './components/js/Views/SignatureErrorPage.vue'
import SignaturePage from './components/js/Views/SignaturePage.vue'
import SimulationPage from './components/js/Views/SimulationPage.vue'
import WalletClientPage from './components/js/Views/WalletClientPage.vue'
import WalletContractListPage from './Views/Wallet/WalletContractListPage.vue'
import WalletContractViewPage from './Views/Wallet/WalletContractViewPage.vue'
import WalletHomePage from './components/js/Views/WalletHomePage.vue'
import useAppRouter from './Composables/useAppRouter.ts'
import useConfig from './Composables/useConfig.ts'
import { useModalMessage } from './Composables/useModalMessage.ts'
import useUser from './Composables/User/useUser.ts'
import { Routes } from './Constants/Routes.ts'
import router from './Routes/index.ts'
import SimulationListPage from './Views/SimulationListPage.vue'
import NotificationListPage from './components/js/Components/Notification/NotificationListPage.vue'

export default function (options) {
  $.fn.datepicker.language = locale

  const i18n = createI18n({
    legacy: false,
    locale: locale,
    messages: messages.getMessages(),
    datetimeFormats: datetimeFormats.getDatetimeFormats(),
    numberFormats: numberFormats.getNumberFormats(),
    datepickerDefinition,
    warnHtmlMessage: false, // suppress warnings about HTML in messages => composition version
    warnHtmlInMessage: 'off', // => legacy version
  })

  const appOptions = Object.assign(
    {
      mixins: [globalVariablesMixin, globalMethodsMixin, jsonRequestMixins],
      props: {},

      data: function () {
        return {
          toasts: [],
          currentRefreshTokenRequest: null,
          jwtToken: config.token,
        }
      },
      methods: {
        getParam: function (name, defaultValue) {
          const queryString = window.location.search
          const urlParams = new URLSearchParams(queryString)
          const value = urlParams.get(name)
          if (value) {
            return value
          } else {
            return defaultValue
          }
        },
        addValue,
        setValue,
        getObjectValueByPropertyPath(object, path, defaultValue = null) {
          if (typeof object !== 'object') {
            return defaultValue
          }

          const properties = path.split('.')
          if (properties.length === 0) {
            return defaultValue
          }

          let value = object
          for (const property of properties) {
            if (!value || !value.hasOwnProperty(property)) {
              value = defaultValue
              break
            }

            value = value[property]
          }

          return value
        },

        setDate: function (data, type) {
          if (data == null) {
            return '-'
          } else {
            return this.$d(new Date(data), type)
          }
        },

        arrayGet,

        sortArray: function (array) {
          let i = 0
          for (const [key, value] of Object.entries(array)) {
            array.splice(i, 0, array.splice(key, 1)[0])
            i++
          }

          const filtered = array.filter((el) => {
            return el !== null && typeof el !== 'undefined' && el != ''
          })

          return filtered
        },

        setHierarchy: function (name, value, fields) {
          let keys = name.split('.')
          let key = keys.shift()
          if (typeof fields[key] == 'undefined') {
            fields[key] = {}
          }
          if (keys.length === 1) {
            fields[key][keys.shift()] = value
          } else {
            fields[key] = this.setHierarchy(keys.join('.'), value, fields[key])
          }
          return fields
        },

        valueAsArray: function (list) {
          let fields = {}
          for (let name in list) {
            let value = list[name]
            if (name.includes('.')) {
              fields = this.setHierarchy(name, value, fields)
            } else {
              fields[name] = value
            }
          }
          return fields
        },

        //fonction qui permet de retourner un object key => value dans l'ordre qu'il reçoit pour pouvoir boucler et retourner des keys dans l'ordre reçu
        sortObjectByKeys(o) {
          return Object.keys(o)
            .sort()
            .reduce((r, k) => ((r[k] = o[k]), r), {})
        },

        //fonction qui retourne le tableau d'objet trier des différents keys
        getSortKeys(o, key, label = null) {
          let arr = []
          o.map((i) => {
            if ((objToSort = i[key])) {
              let objSort = this.sortObjectByKeys(objToSort)
              for (const [index, other] of Object.entries(objSort)) {
                if (other.type != 'json') {
                  if (label) {
                    arr.push(other.label)
                  } else {
                    arr.push(index)
                  }
                }
              }
            }
          })

          return [...new Set(arr)]
        },

        //fonction qui retourne la valeur unique d'un objet en fonction du champs key
        getFieldValueByKey(obj, key, label = null) {
          if (obj[key]) {
            if (obj[key].choiceValue) {
              return obj[key].choiceValue
            } else if (obj[key].choices) {
              for (const [index, choice] of Object.entries(obj[key].choices)) {
                if (index == obj[key].value) {
                  return choice
                }
              }
            }

            return obj[key].value
          } else {
            return ''
          }
        },

        getRound,
        getRoundFloat,
        getNumber,
        escapeHtml(value) {
          return $('<div>').text(value).html()
        },

        getParamsValue(objet, chemin, context = true) {
          let format = null
          if (typeof chemin == 'object') {
            format = chemin.format
            chemin = chemin.field
          }

          //retire le 1er context du chemin
          if (context) {
            const indexPremierPoint = chemin.indexOf('.')

            if (indexPremierPoint !== -1) {
              chemin = chemin.substring(indexPremierPoint + 1)
            }
          }

          const chemins = chemin.split('.')
          let valeur = objet

          //boucle sur le chemin en parcourrant l'objet
          for (const cle of chemins) {
            if (valeur && valeur.hasOwnProperty(cle)) {
              valeur = valeur[cle]
            } else {
              if (format == 'currency') {
                return 0
              } else if (format == 'percent') {
                return 0 + ' %'
              }
              return null
            }
          }

          //retourne la valeur au bon format
          if (format == 'date') {
            return this.setDate(valeur, format)
          } else if (format == 'currency') {
            return this.$n(Number(valeur), format)
          } else if (format == 'boolean') {
            return valeur ? this.$t('main.bool.yes') : this.$t('main.bool.no')
          } else if (format == 'percent') {
            return valeur ? valeur + ' %' : 0 + ' %'
          }
          return valeur
        },

        /**
         * @deprecated use EntityLink in components instead
         */
        renderEntity(data) {
          if (data) {
            if (
              (window.user.isBusinessMan && window.$root?.config?.conf?.theme_dir != 'intellypack') ||
              window.roles.includes('ROLE_APP_ADMIN_ENTITY_FULL')
            ) {
              return '../societe/societe?i=' + data.id + '&n=' + escapeHtml(data.name) + '&p=society'
            }
          }
        },

        getFieldLabel(field, domain = null, label = null, specific = null) {
          if (label != null && this.$te(label)) {
            return this.$t(label)
          }

          if (domain == null && field?.includes('.')) {
            const segments = field.split('.')
            domain = segments.shift()
            field = segments.join('.')
          }

          const translationKey = domain + '.fields.' + field + '.label'

          if (specific != null) {
            let specificTranslationKey = translationKey + '.' + specific
            return this.$te(specificTranslationKey)
              ? this.$t(specificTranslationKey)
              : this.$t(translationKey + '.default')
          }

          if (label != null && !this.$te(label)) {
            return label
          }

          if (!field) {
            return ''
          }

          return this.$t(translationKey)
        },

        getBoolLabel(bool) {
          return bool ? this.$t('main.bool.yes') : this.$t('main.bool.no')
        },

        getConfig() {
          return config
        },
        configureLocale() {
          const language = this.user?.language

          if (!!language && this.$i18n.locale !== language) {
            this.$i18n.locale = language
          }
        },
        // Should be part of useUser
        async refreshUser() {
          this.user = await this.getJSON('users/0')
          user = this.user
        },
        redirectToTotpSetupIfRequired() {
          if (this.user?.mustSetupTotp === true && this.$route.name !== Routes.USER_TOTP_SETUP) {
            this.redirectToRoute({ name: Routes.USER_TOTP_SETUP })
          }
        },
      },
      watch: {
        '$i18n.locale': {
          handler: function (language) {
            Cookies.set('language', language)
          },
        },
        waitingModalMessage: function () {
          this.jsonStatus = this.waitingModalType
          this.jsonStatusText = this.waitingModalMessage
          this.jsonStatusObject = null
          $('#modal-waiting-text').modal({ backdrop: 'static', keyboard: false })
        },
        'user.mustSetupTotp': {
          async handler(value, oldValue) {
            this.redirectToTotpSetupIfRequired()

            if (oldValue === true && value === false) {
              // Force token refresh to have up-to-date user server side
              await this.refreshTokenJWT()
            }
          },
          immediate: true,
        },
        '$route.name': {
          handler(name) {
            if (name !== Routes.USER_TOTP_SETUP) {
              this.redirectToTotpSetupIfRequired()
            }
          },
        },
      },
      setup() {
        const { type, message } = useModalMessage()
        const { user: userRef } = useUser(user)
        const { redirectToRoute } = useAppRouter()

        useConfig(conf) // Set the current config

        return { waitingModalType: type, waitingModalMessage: message, user: userRef, redirectToRoute }
      },

      provide() {
        return {
          Routes,
          getJSON: this.getJSON,
          postJSON: this.postJSON,
          putJSON: this.putJSON,
          patchJSON: this.patchJSON,
          deleteJSON: this.deleteJSON,
          getFile: this.getFile,
          getParam: this.getParam,
          addValue: this.addValue,
          setValue: this.setValue,
          setDate: this.setDate,
          arrayGet: this.arrayGet,
          sortArray: this.sortArray,
          setHierarchy: this.setHierarchy,
          valueAsArray: this.valueAsArray,
          sortObjectByKeys: this.sortObjectByKeys,
          getSortKeys: this.getSortKeys,
          getFieldValueByKey: this.getFieldValueByKey,
          getRound: this.getRound,
          getRoundFloat: this.getRoundFloat,
          getNumber: this.getNumber,
          getParamsValue: this.getParamsValue,
          getFieldLabel: this.getFieldLabel,
          getBoolLabel: this.getBoolLabel,
          escapeHtml: this.escapeHtml,
          includes: this.includes,
          getObjectValueByPropertyPath: this.getObjectValueByPropertyPath,
          getConfig: this.getConfig,
        }
      },

      errorCaptured(err) {
        Sentry.captureException(err)

        return false // Keep this to avoid blank page
      },

      async created() {
        this.user = user

        if (this.user) {
          await this.refreshUser()
          this.configureLocale()
        }
      },

      async mounted() {
        if (!this.user) {
          return
        }

        const redirectAfterLogin = Cookies.get('redirect_url') ?? ''
        if (redirectAfterLogin.includes(document.location.host)) {
          Cookies.remove('redirect_url')
          document.location.href = redirectAfterLogin
        }
      },
    },
    options,
  )

  const app = createApp(appOptions)

  if (import.meta.env.VITE_SENTRY_ENV) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN ?? null,
      sendDefaultPii: true,
      environment: import.meta.env.VITE_SENTRY_ENV,
      release: import.meta.env.VITE_SENTRY_RELEASE ?? 'dev',
      tracingOptions: {
        trackComponents: true,
      },
      integrations: [Sentry.browserTracingIntegration({ router })],
    })
  }

  app.use(i18n)
  app.use(router)

  // Global components
  app.component('FieldCreator', FieldCreator)

  // Register pages in Views folder
  app.component('ClientContractListPage', ClientContractListPage)
  app.component('ContractListPage', ContractListPage)
  app.component('ContractViewPage', ContractViewPage)
  app.component('DemandListPage', DemandListPage)
  app.component('EntityListPage', EntityListPage)
  app.component('EquipmentListPage', EquipmentListPage)
  app.component('InvoiceListPage', InvoiceListPage)
  app.component('KpiPage', KpiPage)
  app.component('SignaturePage', SignaturePage)
  app.component('SignatureErrorPage', SignatureErrorPage)
  app.component('SimulationPage', SimulationPage)
  app.component('SimulationListPage', SimulationListPage)
  app.component('WalletClientPage', WalletClientPage)
  app.component('WalletContractListPage', WalletContractListPage)
  app.component('WalletContractViewPage', WalletContractViewPage)
  app.component('WalletHomePage', WalletHomePage)
  app.component('NotificationListPage', NotificationListPage)

  return app
}
